var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEmptyShareHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42,
    r: 42,
    fill: "url(#paint0_linear_1913_13646)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1913_13646)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7866 29C25.7866 27.9743 26.618 27.1429 27.6437 27.1429H29.5008C30.5265 27.1429 31.358 26.3114 31.358 25.2857C31.358 24.2601 30.5265 23.4286 29.5008 23.4286H27.6437C24.5667 23.4286 22.0723 25.923 22.0723 29V62.4286C22.0723 65.5057 24.5667 68 27.6437 68H57.358C60.4351 68 62.9294 65.5057 62.9294 62.4286V29C62.9294 25.923 60.4351 23.4286 57.358 23.4286H55.5008C54.4751 23.4286 53.6437 24.2601 53.6437 25.2857C53.6437 26.3114 54.4751 27.1429 55.5008 27.1429H57.358C58.3837 27.1429 59.2151 27.9743 59.2151 29V62.4286C59.2151 63.4543 58.3837 64.2857 57.358 64.2857H27.6437C26.618 64.2857 25.7866 63.4543 25.7866 62.4286V29ZM29.5008 42C29.5008 40.9743 30.3323 40.1429 31.358 40.1429H53.6437C54.6694 40.1429 55.5008 40.9743 55.5008 42C55.5008 43.0257 54.6694 43.8571 53.6437 43.8571H31.358C30.3323 43.8571 29.5008 43.0257 29.5008 42ZM31.358 49.4286C30.3323 49.4286 29.5008 50.26 29.5008 51.2857C29.5008 52.3114 30.3323 53.1429 31.358 53.1429H44.358C45.3837 53.1429 46.2151 52.3114 46.2151 51.2857C46.2151 50.26 45.3837 49.4286 44.358 49.4286H31.358Z",
    fill: "#F5D016"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5007 31.0789C35.7754 30.3536 35.7754 29.1777 36.5007 28.4525L45.6931 19.2601C46.4184 18.5348 47.5942 18.5348 48.3195 19.2601C49.0448 19.9854 49.0448 21.1612 48.3195 21.8865L39.1271 31.0789C38.4018 31.8041 37.226 31.8042 36.5007 31.0789Z",
    fill: "#F5D016"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3191 31.0788C47.5938 31.8041 46.4179 31.8041 45.6927 31.0788L36.5003 21.8864C35.775 21.1612 35.775 19.9853 36.5003 19.26C37.2256 18.5348 38.4014 18.5348 39.1267 19.26L48.3191 28.4524C49.0443 29.1777 49.0443 30.3536 48.3191 31.0788Z",
    fill: "#F5D016"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1913_13646",
    x1: 42.5,
    y1: 0,
    x2: 42.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B51F07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D1304"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1913_13646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white",
    transform: "translate(16.5 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmptyShareHistory);
export default __webpack_public_path__ + "static/media/icon_empty_share_history.5f125b13381d61b1007ccaed39763aa6.svg";
export { ForwardRef as ReactComponent };